<div class="center-content">
  <h2>{{esito?.msg}}</h2>
</div>
<div class="center-content-2">
  <h2>{{esito?.msg_secondLine}}</h2>
</div>
